// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.responsive-iframe-container[data-v-654512b0] {\n  width: 70%;\n  height: 70%;\n  height: 500px;\n  min-width: 320px;\n  max-width: 800px;\n}\n.responsive-iframe[data-v-654512b0] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
